module.exports = __webpack_public_path__ + "static/img/share_emoji_02.2a90803.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/share_emoji_02.png
// module id = 2Kjy
// module chunks = 1